import { Component, EventEmitter, Input, Output } from '@angular/core';
import {SelectCustomEvent} from '@ionic/angular';
import {TRACCIATO_FIELD_KEY_TYPES, TracciatoFieldKeyTypes} from '../../../_helpers/TracciatoFieldKeyTypes';

@Component({
    selector: 'app-select-tracciati-field-type-key',
    templateUrl: './select-tracciati-field-type-key.component.html',
    styleUrls: ['./select-tracciati-field-type-key.component.scss'],
    standalone: false
})
export class SelectTracciatiFieldTypeKeyComponent {
  @Input() fieldKeyType: TracciatoFieldKeyTypes;
  @Output() fieldKeyTypeChange = new EventEmitter<TracciatoFieldKeyTypes>();
  tracciatoFieldKeyTypesItem = TRACCIATO_FIELD_KEY_TYPES;
  selectFieldKeyType = (e: SelectCustomEvent) => this.fieldKeyTypeChange.emit(e.target.value);
}
